import React, { FC } from "react";

import { useLabels } from "../../../contexts/labels";
import { MaterialType } from "../../../types/materials";
import { renameFields } from "../../../utils/object";
import { otherMaterial } from "../../forms/forms-fields/materials-form-fields/constants";
import { ExhibitionStrip } from "./exhibition-strip";

export interface ExhibitionSectionProps extends Queries.ExhibitionStripDataFragment {}

export const ExhibitionSection: FC<ExhibitionSectionProps> = (props) => {
  const { labels: stringLabels } = useLabels();
  const labels = renameFields(stringLabels, {
    materials: "forms-materials",
    [MaterialType.Wood]: "materials-wood",
    [MaterialType.Stone]: "materials-stone",
    [MaterialType.Glass]: "materials-glass",
    [MaterialType.Materia]: "materials-materia",
    [MaterialType.Metal]: "materials-metal",
    [otherMaterial]: "materials-other",
  });

  return <ExhibitionStrip labels={labels} {...props} />;
};
